export default __webpack_public_path__ + "static/media/impact5.a398ad30.jpg";